import * as ace from "ace-builds";
import { BaseDiagnostic, DiagnosticSeverity } from "../validation-service";

export class TextDiagnostic extends BaseDiagnostic {
  row: number;
  column: number;
  constructor(row: number, column: number, message: string, severity: DiagnosticSeverity) {
    super(message, severity);
    this.row = row;
    this.column = column;
  }
}

export function aceAnnotationToTextDiagnostic(annotations: ace.Ace.Annotation[]): Array<TextDiagnostic> {
  const result: TextDiagnostic[] = [];
  for (let index = 0; index < annotations.length; index++) {
    const annotation = annotations[index];
    let severity: DiagnosticSeverity;
    if (annotation.type === "error") severity = 2;
    if (annotation.type === "warning") severity = 1;
    result.push(new TextDiagnostic(annotation.row, annotation.column, annotation.text, severity));
  }
  return result;
}
